import type { UserFullName } from 'applications/GSP/shared/utils/user/types';

export const getFullName = <User extends UserFullName>({
  firstName,
  lastName,
}: User) => `${firstName} ${lastName}`;
